import { useMemo } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Input, Chip, ListSubheader } from '@material-ui/core'
import { shouldBeLocked } from '../utils/Roles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: '25ch',
    },
  },
};

const DrugsInvolvedObjects
  = ({ title, stateName, selectedValues, onChange, options, categories, formStyle, labelStyle, chipsStyle, chipStyle, id, disabled, userRoles, ...props }) => {
    const width = title.length + 'ch'

    const memoizedLocked = useMemo(() => shouldBeLocked(disabled, props?.canEdit, userRoles), [disabled, props?.canEdit, userRoles]);


    return (
      <FormControl daya-cy={"DrugsInvolvedObjects-formControl"} id="drugs-involved-formControl" style={{ minWidth: '10vw' }} className={formStyle}>
        <InputLabel data-cy="drugs-involved-label" shrink={true} className={labelStyle} id="drugs-involved-input-label">{title}</InputLabel>
        <Select
          data-cy={title + "-select"}
          inputProps={{ "data-cy": title + "-input-props" }}
          labelId={title + "-label"}
          id={title + id}
          multiple
          disabled={memoizedLocked}
          name={stateName}
          value={selectedValues}
          onChange={onChange}
          input={<Input data-cy={title + "-input"} id={title + id + "-chip"} />}
          MenuProps={MenuProps}
          style={{ minWidth: width }}
          renderValue={selected => {
            return (
              <div className={chipsStyle}>
                {selected.map((value, index) => (
                  <Chip
                    data-cy={title + index + "-chip"}
                    key={value.id}
                    label={value.name}
                    className={chipStyle} />
                ))
                }
              </div>
            )
          }}
        >
          {categories.map((classification, index) => {
            let array = [<ListSubheader style={{ pointerEvents: "none" }} data-cy={'category-' + index} key={classification.id} disableSticky={true}>{classification.name.toUpperCase()}</ListSubheader>]
            options.map((option) => (option.drugClassification.id === classification.id) ? array.push(<MenuItem data-cy={'drug-' + option.id} style={{ color: 'blue', fontWeight: 'bold' }} key={option.id} value={option}>{option.name}</MenuItem>) : null)
            return (array)
          })}

        </Select>
      </FormControl>
    );
  }

export default DrugsInvolvedObjects
  ;